export default __webpack_public_path__ + "static/media/ic-request-quotation.a7037cde.svg";